// Google Ads + GA4 purchase conversion helper.
//
// Used by:
//   - Dashboard.jsx — when a subscription Stripe Checkout returns paid
//   - Validations.jsx — when a credit-pack Stripe Checkout returns paid
//
// Why a shared util:
//   1. Two purchase flows, one event format — guarantees Google Ads sees both
//      as the same Conversion Action.
//   2. Retries up to 10× over 3s if window.gtag hasn't loaded yet (GA script
//      is async-loaded in index.html and may not be ready when polling
//      finishes on a fast connection).
//   3. Optional send_to target — once you paste your Google Ads Conversion
//      Label in index.html (window.__OLY_ADS_CONVERSION_LABEL = "..."),
//      events are sent directly to that Conversion Action. Without it,
//      Google Ads still auto-attributes via the AW-... config in index.html.
//
// Never throws — analytics must never break a checkout return flow.

export function fireAdsConversion({ transaction_id, value, item_id, item_name, currency = "USD" }) {
  if (typeof window === "undefined") return;
  if (!transaction_id || !value) {
    // eslint-disable-next-line no-console
    console.warn("[oly] fireAdsConversion skipped — missing transaction_id or value", { transaction_id, value });
    return;
  }
  const adsLabel = window.__OLY_ADS_CONVERSION_LABEL || null;
  const adsId = window.__OLY_ADS_ID || "AW-9835358546";
  const ga4Id = "G-1N5TKJSVDE";
  const sendTo = adsLabel
    ? [`${adsId}/${adsLabel}`, ga4Id]
    : undefined; // gtag default: send to all configured destinations

  const payload = {
    transaction_id,
    value,
    currency,
    items: [{ item_id, item_name, price: value, quantity: 1 }],
  };
  if (sendTo) payload.send_to = sendTo;

  let tries = 0;
  const attempt = () => {
    if (window.gtag) {
      try {
        window.gtag("event", "purchase", payload);
        // eslint-disable-next-line no-console
        console.log("[oly] ads_conversion fired", { transaction_id, value, item_id, send_to: payload.send_to });
      } catch (e) { /* analytics must never break checkout */ }
      return;
    }
    if (++tries < 10) setTimeout(attempt, 300);
    else {
      // eslint-disable-next-line no-console
      console.warn("[oly] ads_conversion not fired — window.gtag never loaded (was the page opened on a non-prod host?)");
    }
  };
  attempt();
}
